module.exports = __webpack_public_path__ + "static/media/097-switzerland.f8f20a50.svg";